export const EXSBOPERATION_CREATE_RESET = 'EXSBOPERATION_CREATE_RESET'
export const EXSBOPERATION_CREATE_SET_CREATED = 'EXSBOPERATION_CREATE_SET_CREATED'
export const EXSBOPERATION_CREATE_SET_ERROR = 'EXSBOPERATION_CREATE_SET_ERROR'
export const EXSBOPERATION_CREATE_SET_VIOLATIONS = 'EXSBOPERATION_CREATE_SET_VIOLATIONS'
export const EXSBOPERATION_CREATE_TOGGLE_LOADING = 'EXSBOPERATION_CREATE_TOGGLE_LOADING'
